var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55321 10.114C9.05341 10.6142 9.33441 11.2926 9.33441 12C9.33441 12.7074 9.05341 13.3858 8.55321 13.886C8.05301 14.3862 7.37459 14.6672 6.66721 14.6672C5.95982 14.6672 5.28141 14.3862 4.78121 13.886C4.28101 13.3858 4 12.7074 4 12C4 11.2926 4.28101 10.6142 4.78121 10.114C5.28141 9.61377 5.95982 9.33276 6.66721 9.33276C7.37459 9.33276 8.05301 9.61377 8.55321 10.114Z",
    stroke: "#4C70D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2194 4.78095C19.7196 5.28115 20.0006 5.95956 20.0006 6.66695C20.0006 7.37434 19.7196 8.05275 19.2194 8.55295C18.7192 9.05315 18.0408 9.33416 17.3334 9.33416C16.626 9.33416 15.9476 9.05315 15.4474 8.55295C14.9471 8.05262 14.666 7.37402 14.666 6.66645C14.666 5.95887 14.9471 5.28028 15.4474 4.77995C15.9478 4.27962 16.6264 3.99854 17.3339 3.99854C18.0415 3.99854 18.7201 4.27962 19.2204 4.77995",
    stroke: "#4C70D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2192 15.447C19.4669 15.6947 19.6634 15.9887 19.7974 16.3123C19.9314 16.6359 20.0004 16.9827 20.0004 17.333C20.0004 17.6832 19.9314 18.0301 19.7974 18.3537C19.6634 18.6773 19.4669 18.9713 19.2192 19.219C18.9715 19.4667 18.6775 19.6631 18.3539 19.7972C18.0303 19.9312 17.6835 20.0002 17.3332 20.0002C16.983 20.0002 16.6361 19.9312 16.3125 19.7972C15.9889 19.6631 15.6949 19.4667 15.4472 19.219C14.947 18.7188 14.666 18.0404 14.666 17.333C14.666 16.6256 14.947 15.9472 15.4472 15.447C15.9474 14.9468 16.6258 14.6658 17.3332 14.6658C18.0406 14.6658 18.719 14.9468 19.2192 15.447",
    stroke: "#4C70D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04004 10.81L14.96 7.84998",
    stroke: "#4C70D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04004 13.1899L14.96 16.1499",
    stroke: "#4C70D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.8b39a1dc7167833dd0f605a11f7d46ee.svg";
export { ForwardRef as ReactComponent };